export default {
  PAYMENT_METHOD: {
    PURCHASE_ORDER: 'purchaseOrder',
    CREDIT_CARD: 'creditCard',
  },
  CREDIT_CARD_TYPE: {
    AMEX: 'AMEX',
    MASTER: 'MAST',
    VISA: 'VISA',
  },
};
